import { ImageContainer, ImageStyle, ImageTypography } from './table-pics.styles';
import NoProductsPic from '../../../images/no-products.png';

export function NoProducts() {
  return (
    <ImageContainer id='no-products-div'>
      <ImageStyle>
        <img
          id='no-products-img'
          src={NoProductsPic}
          alt='no products were found'
          width='100%'
          height='100%'
        />
      </ImageStyle>
      <ImageTypography>No products found</ImageTypography>
    </ImageContainer>
  );
}
